import { OwnerScope } from '@vivport/backend/types';
import { httpClient } from './http-client';

export interface Work4MeSkillDetail {
  id: number;
  ownerScope: OwnerScope;
  name: string;
  description: string | null;
  body: string;
  isEnabled: boolean;
  updatedAt: string;
}

export interface UpdateWork4MeSkillInput {
  name?: string;
  description?: string | null;
  body?: string;
  isEnabled?: boolean;
}

export interface CreateWork4MeSkillInput {
  ownerType?: 'HUB' | 'MEMBER';
  name: string;
  description?: string | null;
  body: string;
  isEnabled?: boolean;
}

export async function getWork4MeSkill(id: number): Promise<Work4MeSkillDetail> {
  return httpClient.get<Work4MeSkillDetail>(`/protected/skills/${id}`);
}

export async function createWork4MeSkill(input: CreateWork4MeSkillInput): Promise<Work4MeSkillDetail> {
  return httpClient.post<Work4MeSkillDetail, CreateWork4MeSkillInput>('/protected/skills', input);
}

export async function updateWork4MeSkill(
  id: number,
  input: UpdateWork4MeSkillInput
): Promise<Work4MeSkillDetail> {
  return httpClient.patch<Work4MeSkillDetail, UpdateWork4MeSkillInput>(`/protected/skills/${id}`, input);
}

export async function deleteWork4MeSkill(id: number): Promise<void> {
  return httpClient.delete<void>(`/protected/skills/${id}`);
}

